/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2023-01-11 18:43:59
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-04-20 11:22:44
 */
import download from 'downloadjs'
import Axios from 'axios'
import { TokenService } from '@package/service'
import { PROXY_PREFIX } from '../../../../global-constant'

const { getToken } = TokenService

function exportFileDownload({ url, filePath, fileName, fileType }) {
  Axios({
    withcredentials: true,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken('TokenNew')}`,
      'Content-Type': 'application/json'
    },
    url: `${PROXY_PREFIX}${url}`,
    data: { filePath, fileName }, // post
    responseType: 'blob'
  }).then((res) => {
    const blob = new Blob([res.data], { type: fileType })
    // ie兼容处理
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(blob, fileName)
    } else {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      // 下载的文件名
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  })
}

function handleTransLink(url, filename) {
  fetch(url, {
    method: 'get',
    responseType: 'arraybuffer'
  })
    .then(res => {
      if (res.status !== 200) {
        return res.json()
      }
      return res.arrayBuffer()
    })
    .then(blobRes => {
      const e = new Blob([blobRes], {
        type: 'application/octet-stream',
        'Content-Disposition': 'attachment'
      })
      // 将 Blob 对象转为 url
      const link = window.URL.createObjectURL(e)
      // 创建 a 标签
      const el = document.createElement('a')
      el.href = link
      el.download = filename
      el.click()
    })
}

export { download, exportFileDownload, handleTransLink }
